var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoundingBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.375 9.53125L42.625 9.53125C41.5549 9.53125 40.6875 10.3847 40.6875 11.4375L40.6875 19.0625C40.6875 20.1153 41.5549 20.9687 42.625 20.9687L50.375 20.9687C51.4451 20.9687 52.3125 20.1153 52.3125 19.0625L52.3125 11.4375C52.3125 10.3847 51.4451 9.53125 50.375 9.53125Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 9.53125L11.625 9.53125C10.5549 9.53125 9.6875 10.3847 9.6875 11.4375L9.6875 19.0625C9.6875 20.1153 10.5549 20.9687 11.625 20.9687L19.375 20.9687C20.4451 20.9687 21.3125 20.1153 21.3125 19.0625L21.3125 11.4375C21.3125 10.3847 20.4451 9.53125 19.375 9.53125Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.375 40.0312L42.625 40.0312C41.5549 40.0312 40.6875 40.8847 40.6875 41.9375L40.6875 49.5625C40.6875 50.6153 41.5549 51.4687 42.625 51.4687L50.375 51.4687C51.4451 51.4687 52.3125 50.6153 52.3125 49.5625L52.3125 41.9375C52.3125 40.8847 51.4451 40.0312 50.375 40.0312Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 40.0312L11.625 40.0312C10.5549 40.0312 9.6875 40.8847 9.6875 41.9375L9.6875 49.5625C9.6875 50.6153 10.5549 51.4687 11.625 51.4687L19.375 51.4687C20.4451 51.4687 21.3125 50.6153 21.3125 49.5625L21.3125 41.9375C21.3125 40.8847 20.4451 40.0312 19.375 40.0312Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 40.0312L15.5 20.9688",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6875 45.75L21.3125 45.75",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 20.9688L46.5 40.0312",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3125 15.25L40.6875 15.25",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoundingBox);
export default __webpack_public_path__ + "static/media/BoundingBox.9add3d582dae819765c3c1a14ee0d818.svg";
export { ForwardRef as ReactComponent };